import axios from "axios";
import React, {Component} from "react";
import { Link } from "react-router-dom";
import Listprint from "../../Listprint";
import FeatherIcon from "feather-icons-react";
import ReportLine from "./ReportLine";

class Report extends Component{

    state = {
        loading : false,
        columns : [
            {
                label: 'Matr',
                field: 'matricule',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Eleve',
                field: 'student',
                sort: 'asc',
                width: 200
            },
            {
                label: 'Pourcent',
                field: 'studentsuccess',
                sort: 'asc',
                width: 150
            },
            {
                label: 'Classe',
                field: 'classe',
                sort: 'asc',
                width: 120
            },
            {
                label: 'Section',
                field: 'section',
                sort: 'asc',
                width: 120
            },
            {
                label: 'Date',
                field: 'created_at',
                sort: 'asc',
                width: 120
            },
        ],
        sectionclasses : []
    }

    componentDidMount(){
        this.getSectionclasses()
    }

    async getSectionclasses(){
        var sectionclasses = await axios.get('sectionclassestat/report');
        if(sectionclasses.status === 200)
        {
            this.setState({sectionclasses : sectionclasses.data, loading : true}) 
        }
    }

    render(){
        var   max=0, note=0, labels = [], data = [], rows =[];
        this.state.sectionclasses.map(( sectionclasse) => {
            max=0;
            note=0;
            labels.push( sectionclasse.class.short_entitled_class + " " + sectionclasse.title + " " + sectionclasse.section.short_entitled_section)
             sectionclasse.students.map((student) => {
                note += student.studentsuccess
                max += student.studentmax
            })
            data.push(max > 0 ? ((note * 100 ) / max).toFixed(1) : 0 )
            sectionclasse.students.sort((a, b) => ( ( (a.studentsuccess * 100 ) / a.studentmax) < ((b.studentsuccess * 100 ) / b.studentmax) ? 1 : -1 ) ).map((student) => {
                rows.push({
                        matricule : student.user && (<Link to={'/students/'+student.id}  className="text-decoration-none text-primary">{student.matricule}</Link>),
                        student : student.user && (student.user.last_name +" "+ student.user.family_name  +" "+ student.user.first_name ),
                        studentsuccess : student.studentmax > 0 ? ((student.studentsuccess * 100 ) / student.studentmax).toFixed(1)+"%" : "0%",
                        classe : sectionclasse.class.short_entitled_class + " " + sectionclasse.title,
                        section : sectionclasse.section.short_entitled_section,
                        created_at : student.createdAt.slice(0, 10),
                   });
            })
        })
        
        return(
            <div>
                {/* <Helmet>
                    <title>{ process.env.REACT_APP_NAME } | reports student records</title>
                </Helmet> */}
                <div className=" align-items-center pt-3 pb-2 mb-3 border-bottom">
                    <h5 className="h5 font-monospace">Rapport des élèves</h5>
                </div>
                {
                    !this.state.loading && (<FeatherIcon className="user-search-spin" icon="loader" />)
                }

                <div className="h6 text-center text-monospace">Statistique des resultats par classe</div>

                {
                    labels.length > 0 && (
                    <ReportLine
                        labels={labels}
                        data={data}
                        title={
                            "Statistique des resultats par classe " 
                        }
                        />
                    )
                }
                    <div className="h6 text-center text-monospace">Rapport des élève par record des pourcentages</div>
                {
                    rows.length > 0 && (
                    <Listprint columns={this.state.columns} rows={rows} title={"Rapport des élève par record des pourcentages"}/>
                    )
                } 
                

            </div>
        )
    }
}
export default Report